<template>
  <!-- <div class="c-logo" v-show="showLogo">
    <img src="@/assets/img/betterdoc_logo.svg" alt="BetterDoc Logo" />
  </div>
  <p>
    <b
      >Bitte lesen und bestätigen Sie, dass Sie mit den Datenschutzbestimmungen
      einverstanden sind.</b
    >
  </p> -->
  <ion-list lines="none">
    <!-- <ion-item>
      <ion-checkbox slot="start" v-model="privacy1"> </ion-checkbox>
      <ion-label class="ion-text-wrap" color="primary">
        Ich möchte von BetterDoc kontaktiert werden und stimme der
        <u class="u-bold"
          ><a href="#" @click.prevent="openInfoModal(privacy1Text)"
            >Verarbeitung meiner personenbezogenen Daten
          </a></u
        >
        durch BetterDoc zu.
      </ion-label>
    </ion-item> -->
    <ion-row class="ion-align-items-center">
      <ion-col>
        <ion-item>
          <ion-checkbox
            slot="start"
            v-model="privacyRoodieCheck"
            @ionChange="$emit('privacy-roodie-checked', $event.detail.checked)"
            :class="{ 'u-danger': privacyRoodieCheckboxColor === 'danger' }"
          >
          </ion-checkbox>
          <ion-label
            v-if="routing === 'BetterDoc'"
            class="ion-text-wrap"
            color="primary"
          >
            Ich willige ein, mein gesundheitliches Anliegen {{ filesText }}und
            meine
            {{
              from === "contact"
                ? "personenbezogenen Daten"
                : "personenbezogenen Gesundheitsdaten"
            }}
            BetterDoc zum Zweck der Unterstützung für mein gesundheitliches
            Anliegen und einer etwaig damit verbundenen Suche nach passenden
            Gesundheitsdienstleistern bereitzustellen und stimme der
            Verarbeitung dieser ausschließlich zu diesem Zweck zu und nehme die
            <u class="u-bold"
              ><a
                href="#"
                @click.prevent="
                  $browser.open({
                    url: 'https://www.roodie-health.com/arag/datenschutz',
                  })
                "
                >Datenschutzinformationen</a
              ></u
            >
            zur Kenntnis. Diese Einwilligung kann von Ihnen jederzeit widerrufen
            werden.
            <a
              href="#"
              @click.prevent="openInfoModal(privacy2Text)"
              style="text-decoration: none"
              >MEHR</a
            >
          </ion-label>
          <ion-label
            v-else-if="routing === 'Quality Smile'"
            class="ion-text-wrap"
            color="primary"
          >
            Ich willige ein, mein gesundheitliches Anliegen {{ filesText }}und
            meine
            {{
              from === "contact"
                ? "personenbezogenen Daten"
                : "personenbezogenen Gesundheitsdaten"
            }}
            dem Patientenservice von Quality Smile zum Zweck der Unterstützung
            für mein gesundheitliches Anliegen und einer etwaig damit
            verbundenen Suche nach passenden Gesundheitsdienstleistern
            bereitzustellen und stimme der Verarbeitung dieser ausschließlich zu
            diesem Zweck zu und nehme die
            <u class="u-bold"
              ><a
                href="#"
                @click.prevent="
                  $browser.open({
                    url: 'https://www.roodie-health.com/arag/datenschutz',
                  })
                "
                >Datenschutzinformationen</a
              ></u
            >
            zur Kenntnis. Diese Einwilligung kann von Ihnen jederzeit widerrufen
            werden.
            <a
              href="#"
              @click.prevent="openInfoModal(privacy2Text)"
              style="text-decoration: none"
              >MEHR</a
            >
          </ion-label>
          <ion-label
            v-else-if="routing === 'MedicalContact'"
            class="ion-text-wrap"
            color="primary"
          >
            Ich willige ein, mein gesundheitliches Anliegen {{ filesText }}und
            meine
            {{
              from === "contact"
                ? "personenbezogenen Daten"
                : "personenbezogenen Gesundheitsdaten"
            }}
            der Medical Contact AG zum Zweck der Unterstützung für mein
            gesundheitliches Anliegen bereitzustellen und stimme der
            Verarbeitung dieser ausschließlich zu diesem Zweck zu und nehme die
            <u class="u-bold"
              ><a
                href="#"
                @click.prevent="
                  $browser.open({
                    url: 'https://www.roodie-health.com/arag/datenschutz',
                  })
                "
                >Datenschutzinformationen</a
              ></u
            >
            zur Kenntnis. Diese Einwilligung kann von Ihnen jederzeit widerrufen
            werden.
            <a
              href="#"
              @click.prevent="openInfoModal(privacy2Text)"
              style="text-decoration: none"
              >MEHR</a
            >
          </ion-label>
          <template
            v-else-if="
              routing.startsWith('ARAG Case Management') || from === 'contact'
            "
          >
            <ion-label class="ion-text-wrap" color="primary">
              Ich willige ein, mein gesundheitliches Anliegen {{ filesText }}und
              meine
              {{
                from === "contact"
                  ? "personenbezogenen Daten"
                  : "personenbezogenen Gesundheitsdaten"
              }}
              den ARAG Gesundheitsassistenten
              {{ from === "contact" ? "" : aragRoutingSuffix }} zum Zweck der
              Unterstützung für mein gesundheitliches Anliegen und einer etwaig
              damit verbundenen Suche nach passenden Gesundheitsdienstleistern
              bereitzustellen und stimme der Verarbeitung dieser ausschließlich
              zu diesem Zweck zu und nehme die
              <u class="u-bold"
                ><a
                  href="#"
                  @click.prevent="
                    $browser.open({
                      url: 'https://www.roodie-health.com/arag/datenschutz',
                    })
                  "
                  >Datenschutzinformationen</a
                ></u
              >
              zur Kenntnis. Diese Einwilligung kann von Ihnen jederzeit
              widerrufen werden.
              <a
                href="#"
                @click.prevent="openInfoModal(privacy2Text)"
                style="text-decoration: none"
                >MEHR</a
              >
            </ion-label>
            <!-- <ion-label v-else class="ion-text-wrap" color="primary">
              Ich möchte meinen Roodie.Check {{ filesText }}den ARAG
              Gesundheitsassistenten zum Zweck der Unterstützung für mein
              gesundheitliches Anliegen und einer etwaig damit verbundenen Suche
              nach passenden Gesundheitsdienstleistern bereitstellen und
              akzeptiere die
              <u class="u-bold"
                ><a
                  href="#"
                  @click.prevent="
                    $browser.open({
                      url: 'https://www.roodie-health.com/arag/datenschutz',
                    })
                  "
                  >Datenschutzinformationen</a
                ></u
              >.
              <a
                href="#"
                @click.prevent="openInfoModal(privacy2Text)"
                style="text-decoration: none;"
                >MEHR</a
              >
            </ion-label> -->
          </template>
          <ion-label v-else class="ion-text-wrap" color="primary">
            Ich möchte meinen Roodie.Check {{ filesText }}als Vorbereitung für
            das Gespräch mit {{ routingText }} teilen.
          </ion-label>
        </ion-item>
      </ion-col>
      <ion-col size="auto" v-if="from !== 'contact'">
        <ion-button
          @click="setPopoverOpen(true, $event)"
          fill="clear"
          class="ion-no-padding"
        >
          <ion-icon :icon="informationCircle"></ion-icon>
        </ion-button>
        <ion-popover
          :is-open="isPopoverOpenRef"
          :event="popoverEvent"
          @didDismiss="setPopoverOpen(false)"
          mode="ios"
          css-class="c-tip-popover"
        >
          <ion-content class="ion-padding"
            >Teilen Sie Ihren Roodie.Check im Vorfeld, damit die
            Arzt-/Kliniksuche gezielt für Sie starten kann. Wir bitten um
            Verständnis, dass
            {{
              routing.startsWith("ARAG Case Management")
                ? "die ARAG Gesundheitsassistenten"
                : routing
            }}
            ansonsten nochmals all diese Informationen zu Ihrem gesundheitlichen
            Anliegen von Ihnen erfragen
            {{
              routing.startsWith("ARAG Case Management") ? "müssen" : "muss"
            }}.
          </ion-content>
        </ion-popover>
      </ion-col>
    </ion-row>
    <ion-row class="ion-align-items-center">
      <ion-col>
        <ion-item>
          <ion-checkbox slot="start" v-model="privacy2"> </ion-checkbox>
          <ion-label
            v-if="routing === 'MedicalContact'"
            class="ion-text-wrap"
            color="primary"
          >
            Ich willige ein, dass die Medical Contact AG den Status zu meiner
            Leistungsinanspruchnahme an Roodie zurückübermittelt, um diese
            Informationen in meinem Konto in der Roodie ARAG App zu speichern.
            Diese Einwilligung kann von mir jederzeit widerrufen werden.
          </ion-label>
          <ion-label
            v-else-if="
              routing.startsWith('ARAG Case Management') || from === 'contact'
            "
            class="ion-text-wrap"
            color="primary"
          >
            Ich willige ein, dass die ARAG Krankenversicherungs-AG alle Angaben
            zu meinem gesundheitlichen Anliegen {{ filesText }}und meine
            personenbezogenen Daten an medizinische Fachberater übermittelt,
            soweit dies zur Prüfung der Leistungspflicht erforderlich ist und
            meine Gesundheitsdaten dort zweckentsprechend verwendet und die
            Ergebnisse an die ARAG Krankenversicherungs-AG zurück übermittelt
            werden. Im Hinblick auf meine Gesundheitsdaten und weitere nach §
            203 STGB geschützte Daten entbinde ich die für die
            ARAG-Krankenversicherung tätigen Personen und die Fachberater von
            der Schweigepflicht und nehme die
            <u class="u-bold"
              ><a
                href="https://www.arag.de/datenschutzerklaerung/"
                target="_blank"
                >Datenschutzerklärung</a
              ></u
            >
            zur Kenntnis. Diese Einwilligung kann von mir jederzeit widerrufen
            werden.
            <a
              href="#"
              @click.prevent="openInfoModal(privacyRevocationText)"
              style="text-decoration: none"
              >MEHR</a
            >
          </ion-label>
          <ion-label
            v-else-if="routing === 'BetterDoc'"
            class="ion-text-wrap"
            color="primary"
          >
            Ich willige ein, dass BetterDoc alle Angaben zu meinem
            gesundheitlichen Anliegen und bei direkter Terminvereinbarung auch
            meine personenbezogenen Daten an Ärzte/Kliniken übermittelt, soweit
            dies ausschließlich zur Erfüllung dieses Zwecks erforderlich ist und
            meine Gesundheitsdaten dort zweckentsprechend verwendet und die
            Ergebnisse an BetterDoc und von diesen wiederum an Roodie zurück
            übermittelt werden, um diese Informationen in Ihrem Konto in der
            Roodie ARAG App zu speichern. Im Hinblick auf meine Gesundheitsdaten
            und weitere nach § 203 STGB geschützte Daten entbinde ich die für
            BetterDoc tätigen Personen von der Schweigepflicht und nehme die
            <u class="u-bold"
              ><a
                href="https://www.betterdoc.org/datenschutzbestimmungen"
                target="_blank"
                >Datenschutzbestimmungen</a
              ></u
            >
            zur Kenntnis. Diese Einwilligung kann von mir jederzeit widerrufen
            werden.
            <a
              href="#"
              @click.prevent="openInfoModal(privacyRevocationText)"
              style="text-decoration: none"
              >MEHR</a
            >
          </ion-label>
          <ion-label
            v-else-if="routing === 'Quality Smile'"
            class="ion-text-wrap"
            color="primary"
          >
            Ich willige ein, dass das Patientenservice der Quality Smile GmbH
            alle Angaben zu meinem gesundheitlichen Anliegen und bei direkter
            Terminvereinbarung auch meine personenbezogenen Daten an
            Zahnärzte/-labore übermittelt, soweit dies ausschließlich zur
            Erfüllung dieses Zwecks erforderlich ist und meine Gesundheitsdaten
            dort zweckentsprechend verwendet und die Ergebnisse an Quality Smile
            und von diesen wiederum an Roodie zurück übermittelt werden, um
            diese Informationen in Ihrem Konto in der Roodie ARAG App zu
            speichern. Im Hinblick auf meine Gesundheitsdaten und weitere nach §
            203 STGB geschützte Daten entbinde ich die für Quality Smile tätigen
            Personen von der Schweigepflicht und nehme die
            <u class="u-bold"
              ><a
                href="#"
                @click.prevent="
                  $browser.open({
                    url: 'https://quality-smile.de/start/datenschutz/',
                  })
                "
                >Datenschutzerklärung</a
              ></u
            >
            zur Kenntnis. Diese Einwilligung kann von mir jederzeit widerrufen
            werden.
            <a
              href="#"
              @click.prevent="openInfoModal(privacyRevocationText)"
              style="text-decoration: none"
              >MEHR</a
            >
          </ion-label>
          <ion-label v-else class="ion-text-wrap" color="primary">
            Ich suche einen Arzt und möchte Unterstützung durch
            {{ routing }} bei der Arzt-/Kliniksuche und akzeptiere die
            <u class="u-bold"
              ><a href="#" @click.prevent="openInfoModal(privacy2Text)"
                >Datenschutzbestimmungen</a
              ></u
            >.
          </ion-label>
        </ion-item>
      </ion-col>
      <ion-col size="auto" v-if="from !== 'contact'">
        <ion-button
          @click="setPrivacy2PopoverOpen(true, $event)"
          fill="clear"
          class="ion-no-padding"
        >
          <ion-icon :icon="informationCircle"></ion-icon>
        </ion-button>
        <ion-popover
          :is-open="isPrivacy2PopoverOpenRef"
          :event="popoverEvent"
          @didDismiss="setPrivacy2PopoverOpen(false)"
          mode="ios"
          css-class="c-tip-popover"
        >
          <ion-content class="ion-padding"
            >Um Sie bei der Arzt-/Kliniksuche zu unterstützen, braucht es Ihre
            Zustimmung. Wir bitten um Verständnis, dass wir Ihnen ansonsten bei
            Ihrem gesundheitlichen Anliegen nicht helfen können.
          </ion-content>
        </ion-popover>
      </ion-col>
    </ion-row>
    <!-- <ion-item v-if="showShouldSave">
      <ion-checkbox
        slot="start"
        v-model="shouldSave"
        @ionChange="$emit('should-save-checked', $event.detail.checked)"
        :class="{ 'u-danger': shouldSaveCheckboxColor === 'danger' }"
      >
      </ion-checkbox>
      <ion-label class="ion-text-wrap" color="primary">
        Ich möchte meinen Roodie.Check {{ filesText }}speichern und akzeptiere
        die
        <u class="u-bold"
          ><a
            href="#"
            @click.prevent="
              $browser.open({
                url: 'https://www.roodie-health.com/arag/datenschutz',
              })
            "
            >Datenschutzinformationen</a
          ></u
        >.
        <a
          href="#"
          @click.prevent="openInfoModal(privacy3Text)"
          style="text-decoration: none;"
          >MEHR</a
        >
      </ion-label>
    </ion-item> -->
  </ion-list>
  <!-- <ion-row v-if="showNextButton">
    <ion-col>
      <next-question-button
        :disabled="!privacy1 || !privacy2"
        @click="submit"
      />
    </ion-col>
  </ion-row> -->
</template>

<script>
import {
  IonList,
  IonItem,
  IonCheckbox,
  IonLabel,
  modalController,
  IonRow,
  IonCol,
  IonButton,
  IonIcon,
  IonPopover,
  IonContent,
} from "@ionic/vue";
// import NextQuestionButton from "@lib/components/Questions/NextQuestionButton";
import InfoModal from "@lib/components/InfoModal";
import { informationCircle } from "ionicons/icons";
import { ref } from "vue";
import { generalPrivacyPolicy } from "@/utils/basics";

export default {
  emits: [
    "done",
    "checked",
    "unchecked",
    "privacy-roodie-checked",
    "should-save-checked",
  ],
  components: {
    IonList,
    IonItem,
    IonCheckbox,
    IonLabel,
    // NextQuestionButton,
    IonRow,
    IonCol,
    IonButton,
    IonIcon,
    IonPopover,
    IonContent,
  },
  props: {
    link: {
      required: false,
      type: String,
      default: "",
    },
    showLogo: {
      required: false,
      type: Boolean,
      default: true,
    },
    showNextButton: {
      required: false,
      type: Boolean,
      default: true,
    },
    showPrivacy2: {
      required: false,
      type: Boolean,
      default: true,
    },
    routing: {
      required: false,
      type: String,
      default: "BetterDoc",
    },
    routingText: {
      required: false,
      type: String,
      default: "",
    },
    selectedCondition: {
      required: false,
      type: Object,
      default: () => {
        return {};
      },
    },
    showShouldSave: {
      required: false,
      type: Boolean,
      default: true,
    },
    from: {
      required: false,
      type: String,
      default: "",
    },
    files: {
      required: false,
      type: Array,
      default: null,
    },
    userFiles: {
      required: false,
      type: Array,
      default: null,
    },
    partnerFiles: {
      required: false,
      type: Array,
      default: null,
    },
    privacyRoodieCheckboxColor: {
      required: false,
      type: String,
      default: "primary",
    },
    shouldSaveCheckboxColor: {
      required: false,
      type: String,
      default: "primary",
    },
    forceAllPrivacies: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      privacyRoodieCheck: false,
      // privacy1: false,
      privacy2: false,
      shouldSave: false,
      generalPrivacyPolicy,
      // privacy1Text:
      //   "<p>Ihre angegebenen Daten (Vorname, Nachname, Geschlecht, PLZ, Wohnort, Angebe zum Versicherungstarif) werden im Zuge der Vertragserfüllung an BetterDoc, und anschließend an die ARAG weitergegeben und von der ARAG zur Abrechnung verarbeitet. Die Rechtsgrundlage iSd Datenschutz-Grundverordnung (DSGVO) ist hierbei Art 6 Abs 1 lit b DSGVO.</p><p>Die bei BetterDoc in diesem Zusammenhang gespeicherten Daten werden ausschließlich zu Zwecken des telefonischen Rückrufs oder zur Kontaktaufnahme per E-Mail verarbeitet. Sie können jederzeit die Kontaktaufnahme untersagen oder die Löschung Ihrer Daten verlangen. (Widerrufsmöglichkeit der Einwilligung gemäß Art 7 Abs.3 DSGVO)</p>",
    };
  },
  computed: {
    aragRoutingSuffix() {
      let result = "";
      if (this.routing === "ARAG Case Management Zahn") {
        result = "ZAHN";
      } else if (this.routing === "ARAG Case Management Mental") {
        result = "MENTAL";
      }
      return result;
    },
    isNoRoodieCheck() {
      return (
        ["toothCosmetic", "toothTreatmentplan"].includes(
          this.selectedCondition.name
        ) || this.from === "contact"
      );
    },
    filesText() {
      let result = "";
      if (
        this.files?.length ||
        this.userFiles?.length ||
        this.partnerFiles?.length ||
        this.forceAllPrivacies
      ) {
        result = "samt (kieferorthopädischem) Behandlungsplan ";
      }
      return result;
    },
    privacy1Label() {
      let result =
        "Ich willige ein, mein gesundheitliches Anliegen " +
        this.filesText +
        "und meine " +
        (this.from === "contact"
          ? "personenbezogenen Daten "
          : "personenbezogenen Gesundheitsdaten ");
      if (this.routing === "BetterDoc") {
        // result =
        //   "Ich möchte meinen Roodie.Check " +
        //   "dem medizinischen Fachpersonal von BetterDoc zum Zweck der Unterstützung für mein gesundheitliches Anliegen und einer etwaig damit verbundenen Suche nach passenden Gesundheitsdienstleistern bereitstellen und akzeptiere die Datenschutzinformationen.";
        result += "BetterDoc";
      } else if (this.routing === "Quality Smile") {
        // result =
        //   "Ich möchte meinen Roodie.Check " +
        //   "mit dem Patientenservice von Quality Smile zum Zweck der Unterstützung für mein gesundheitliches Anliegen und einer etwaig damit verbundenen Suche nach passenden Zahnärzten/-laboren bereitstellen und akzeptiere die Datenschutzinformationen.";
        result += "dem Patientenservice von Quality Smile";
      } else if (
        this.routing.startsWith("ARAG Case Management") ||
        this.from === "contact"
      ) {
        // if (this.isNoRoodieCheck) {
        //   result =
        //     "Ich willige ein, mein gesundheitliches Anliegen " +
        //     this.filesText +
        //     "und meine personenbezogenen Daten den ARAG Gesundheitsassistenten zum Zweck der Unterstützung für mein gesundheitliches Anliegen und einer etwaig damit verbundenen Suche nach passenden Gesundheitsdienstleistern bereitzustellen und stimme der Verarbeitung dieser ausschließlich zu diesem Zweck zu und nehme die Datenschutzinformationen zur Kenntnis. Diese Einwilligung kann von Ihnen jederzeit widerrufen werden.";
        // } else {
        //   result =
        //     "Ich möchte meinen Roodie.Check " +
        //     this.filesText +
        //     "den ARAG Gesundheitsassistenten zum Zweck der Unterstützung für mein gesundheitliches Anliegen und einer etwaig damit verbundenen Suche nach passenden Gesundheitsdienstleistern bereitstellen und akzeptiere die Datenschutzinformationen.";
        // }
        result +=
          "den ARAG Gesundheitsassistenten " +
          (this.from === "contact" ? "" : this.aragRoutingSuffix);
      }
      // else {
      //   result =
      //     "Ich möchte meinen Roodie.Check " +
      //     this.filesText +
      //     "als Vorbereitung für das Gespräch mit " +
      //     this.routingText +
      //     " teilen.";
      // }
      result +=
        " zum Zweck der Unterstützung für mein gesundheitliches Anliegen und einer etwaig damit verbundenen Suche nach passenden Gesundheitsdienstleistern bereitzustellen und stimme der Verarbeitung dieser ausschließlich zu diesem Zweck zu und nehme die Datenschutzinformationen zur Kenntnis. Diese Einwilligung kann von Ihnen jederzeit widerrufen werden." +
        this.privacy2Text;
      return result;
    },
    privacy2Label() {
      let result = "";
      if (
        this.routing.startsWith("ARAG Case Management") ||
        this.from === "contact"
      ) {
        result =
          "Ich willige ein, dass die ARAG Krankenversicherungs-AG alle Angaben zu meinem gesundheitlichen Anliegen " +
          this.filesText +
          "und meine personenbezogenen Daten an medizinische Fachberater übermittelt, soweit dies zur Prüfung der Leistungspflicht erforderlich ist und meine Gesundheitsdaten dort zweckentsprechend verwendet und die Ergebnisse an die ARAG Krankenversicherungs-AG zurück übermittelt werden. Im Hinblick auf meine Gesundheitsdaten und weitere nach § 203 STGB geschützte Daten entbinde ich die für die ARAG-Krankenversicherung tätigen Personen und die Fachberater von der Schweigepflicht und nehme die Datenschutzerklärung zur Kenntnis. Diese Einwilligung kann von mir jederzeit widerrufen werden.";
      } else if (this.routing === "BetterDoc") {
        result =
          "Ich willige ein, dass BetterDoc alle Angaben zu meinem gesundheitlichen Anliegen und bei direkter Terminvereinbarung auch meine personenbezogenen Daten an Ärzte/Kliniken übermittelt, soweit dies ausschließlich zur Erfüllung dieses Zwecks erforderlich ist und meine Gesundheitsdaten dort zweckentsprechend verwendet und die Ergebnisse an BetterDoc und von diesen wiederum an Roodie zurück übermittelt werden, um diese Informationen in Ihrem Konto in der Roodie ARAG App zu speichern. Im Hinblick auf meine Gesundheitsdaten und weitere nach § 203 STGB geschützte Daten entbinde ich die für BetterDoc tätigen Personen von der Schweigepflicht und nehme die Datenschutzbestimmungen zur Kenntnis. Diese Einwilligung kann von mir jederzeit widerrufen werden.";
      } else if (this.routing === "Quality Smile") {
        result =
          "Ich willige ein, dass das Patientenservice der Quality Smile GmbH alle Angaben zu meinem gesundheitlichen Anliegen und bei direkter Terminvereinbarung auch meine personenbezogenen Daten an Zahnärzte/-labore übermittelt, soweit dies ausschließlich zur Erfüllung dieses Zwecks erforderlich ist und meine Gesundheitsdaten dort zweckentsprechend verwendet und die Ergebnisse an Quality Smile und von diesen wiederum an Roodie zurück übermittelt werden, um diese Informationen in Ihrem Konto in der Roodie ARAG App zu speichern. Im Hinblick auf meine Gesundheitsdaten und weitere nach § 203 STGB geschützte Daten entbinde ich die für Quality Smile tätigen Personen von der Schweigepflicht und nehme die Datenschutzerklärung zur Kenntnis. Diese Einwilligung kann von mir jederzeit widerrufen werden.";
      } else {
        result =
          "Ich suche einen Arzt und möchte Unterstützung durch " +
          this.routing +
          " bei der Arzt-/Kliniksuche und akzeptiere die Datenschutzbestimmungen.";
      }
      result += this.privacyRevocationText;
      return result;
    },
    privacy2Text() {
      let result =
        "<p>Bei Ihren personenbezogenen Daten handelt es sich um Ihre Angaben zu Ihrem gesundheitlichen Anliegen sowie um Anrede, Vorname, Nachname, Alter, Anschrift, Telefonnummer und E-Mail-Adresse einschließlich der Versicherungsnummer Ihrer ARAG-Krankenversicherung. Ferner werden Arzt-/Klinikvorschläge sowie bei Vereinbarung eines Termins die Daten von behandelnden Gesundheitsdienstleistern (Vorname, Nachname, Fachrichtung, Anschrift), Zeitpunkt und Ort des Termins von ";
      if (this.routing === "BetterDoc") {
        // result =
        //   "<p>Die Angaben zu Ihrem gesundheitlichen Anliegen (u.a. Symptomen), Anrede, Vorname, Nachname, Alter, Anschrift, Ihre Kontaktdaten (Telefonnummer sowie E-Mail-Adresse) und die Versicherungsnummer Ihrer ARAG-Krankenversicherung werden von Roodie an die BetterDoc GmbH zum Zweck der Kontaktaufnahme mit Ihnen und der Arzt-/Kliniksuche weitergegeben und von dieser ausschließlich zu diesem Zweck verarbeitet und genutzt.  Ferner werden Arzt-/Klinikvorschläge sowie bei Vereinbarung eines Arzt-/Kliniktermins die Daten des/der behandelnden Arztes/Klinik (Vorname, Nachname, Fachrichtung), Zeitpunkt und Ort des Termins von BetterDoc an Roodie übermittelt, um diese Informationen in Ihrem Konto in der Roodie ARAG App anzuzeigen und zu speichern. Diese Einwilligung kann von Ihnen jederzeit widerrufen werden.</p><p>Es handelt sich dabei um personenbezogene Daten, die sich auf Ihre körperliche oder mentale Gesundheit, einschließlich der Erbringung von Gesundheitsdienstleistungen beziehen und aus denen Informationen über Ihren Gesundheitszustand hervorgehen. Rechtsgrundlage für die Verarbeitung dieser Daten ist Ihre Einwilligung gemäß Art 9 Abs 2 lit a DSGVO. Bitte beachten Sie, dass bei Weiterleitung an BetterDoc bekannt wird, dass für Sie eine Krankenversicherung bei der ARAG-Krankenversicherung besteht.</p>";
        result += "BetterDoc";
      } else if (this.routing === "MedicalContact") {
        result += "der Medical Contact AG";
      } else if (
        this.routing.startsWith("ARAG Case Management") ||
        this.from === "contact"
      ) {
        // result =
        //   "<p>Die Angaben zu meinen Symtomen, Vorname, Nachname, Alter und Geschlecht, Telefonnummer und die Angaben zur Ihren Vertragsdaten (E-Mail-Adresse, Versicherungsnummer, Geburtsdatum) werden an die ARAG weitergegeben und von diesen gespeichert, um Sie betreuen zu können. Um Ihre Suchanfrage beantworten zu können, benötigt ARAG von Ihnen Angaben zu Ihrer physischen und möglicherweise auch psychischen Verfassung. Hierbei handelt es sich um Gesundheitsdaten im Sinne der Datenschutz-Grundverordnung, Art. 4 Nr. 15 DSGVO. Ferner werden die Angaben, die der Nutzer im Zusammenhang mit einer auf seinen Wunsch erfolgenden Vereinbarung eines Termins bei einem Arzt durch die Vermittlung über das ARAG Case Management macht, sowie Angaben, die er im Rahmen der Nachbetreuung macht, verarbeitet.  Es handelt sich dabei um personenbezogene Daten, die sich auf die körperliche oder geistige Gesundheit einer natürlichen Person, einschließlich der Erbringung von Gesundheitsdienstleistungen beziehen und aus denen Informationen über deren Gesundheitszustand hervorgehen. Rechtsgrundlage für die Verarbeitung dieser Daten ist Ihre Einwilligung gemäß Art. 9 Abs. 2 lit. a DSGVO.</p>";
        // if (this.isNoRoodieCheck) {
        //   result =
        //     "<p>Bei Ihren personenbezogenen Daten handelt es sich um Ihre Angaben zu Ihrem gesundheitlichen Anliegen sowie um Anrede, Vorname, Nachname, Alter, Anschrift, Telefonnummer und E-Mail-Adresse einschließlich der Versicherungsnummer Ihrer ARAG-Krankenversicherung. Ferner werden Arzt-/Klinikvorschläge sowie bei Vereinbarung eines Termins die Daten von behandelnden Gesundheitsdienstleistern (Vorname, Nachname, Fachrichtung, Anschrift), Zeitpunkt und Ort des Termins von der ARAG Krankenversicherungs-AG an Roodie übermittelt, um diese Informationen in Ihrem Konto in der Roodie ARAG App zu speichern und anzuzeigen.</p><p>Es handelt sich dabei um personenbezogene Daten, die sich auf Ihre körperliche oder mentale Gesundheit, einschließlich der Erbringung von Gesundheitsdienstleistungen beziehen und aus denen Informationen über Ihren Gesundheitszustand hervorgehen. Rechtsgrundlage für die Verarbeitung dieser Daten ist Ihre Einwilligung gemäß Art 9 Abs 2 lit a DSGVO.</p>";
        // } else {
        //   result =
        //     "<p>Die Angaben zu Ihren Symptomen, Anrede, Vorname, Nachname, Alter, Anschrift, Ihre Kontaktdaten (Telefonnummer sowie E-Mail-Adresse) und die Versicherungsnummer Ihrer ARAG-Krankenversicherung werden von Roodie an die ARAG Krankenversicherungs-AG zum Zweck der Unterstützung für Ihr gesundheitliches Anliegen und/oder Suche nach Gesundheitsdienstleistern weitergegeben und von dieser ausschließlich zu diesem Zweck verarbeitet und genutzt. Ferner werden Arzt-/Klinikvorschläge sowie bei Vereinbarung eines Termins die Daten von behandelnden Gesundheitsdienstleistern (Vorname, Nachname, Fachrichtung, Anschrift), Zeitpunkt und Ort des Termins von der ARAG Krankenversicherungs-AG an Roodie übermittelt, um diese Informationen in Ihrem Konto in der Roodie ARAG App zu speichern. Diese Einwilligung kann von Ihnen jederzeit widerrufen werden.</p><p>Es handelt sich dabei um personenbezogene Daten, die sich auf Ihre körperliche oder mentale Gesundheit, einschließlich der Erbringung von Gesundheitsdienstleistungen beziehen und aus denen Informationen über Ihren Gesundheitszustand hervorgehen. Rechtsgrundlage für die Verarbeitung dieser Daten ist Ihre Einwilligung gemäß Art 9 Abs 2 lit a DSGVO.</p>";
        // }
        result += "der ARAG Krankenversicherungs-AG";
      } else if (this.routing === "Quality Smile") {
        result += "der Quality Smile GmbH";
      }
      result +=
        " an Roodie übermittelt, um diese Informationen in Ihrem Konto in der Roodie ARAG App zu speichern und anzuzeigen.</p><p>Es handelt sich dabei um personenbezogene Daten, die sich auf Ihre körperliche oder mentale Gesundheit, einschließlich der Erbringung von Gesundheitsdienstleistungen beziehen und aus denen Informationen über Ihren Gesundheitszustand hervorgehen. Rechtsgrundlage für die Verarbeitung dieser Daten ist Ihre Einwilligung gemäß Art 9 Abs 2 lit a DSGVO.</p>";
      return result;
    },
    privacy3Text() {
      return "<p>Die Angaben zu Ihren Symptomen bzw. Ihrem gesundheitlichen Anliegen werden in Ihrem Nutzerkonto im Menü unter Roodie.Safe gespeichert, damit Sie dort jederzeit auf sie zugreifen können und um bei Aktivierung unseres Benachrichtigungsservices bei Ihnen beispielhaft zu erfragen,  ob ein Termin zu Ihrer Zufriedenheit verlaufen ist, um uns nach Ihrem Wohlbefinden und/oder Genesungsfortschritt zu erkundigen, Sie an Termine zu erinnern und um Ihnen weiterführende Unterstützung von Gesundheitsdienstleistungspartnern zugänglich zu machen.</p><p>Es handelt sich dabei um personenbezogene Daten, die sich auf Ihre körperliche oder mentale Gesundheit, einschließlich der Erbringung von Gesundheitsdienstleistungen beziehen und aus denen Informationen über Ihren Gesundheitszustand hervorgehen. Rechtsgrundlage für die Verarbeitung dieser Daten ist Ihre Einwilligung gemäß Art 9 Abs 2 lit a DSGVO.</p>";
    },
    privacyQualitySmileText() {
      return "<p>Die Angaben zu Ihrem gesundheitlichen Anliegen, Anrede, Vorname, Nachname, Alter, Anschrift, Ihre Kontaktdaten (Telefonnummer sowie E-Mail-Adresse) und die Versicherungsnummer Ihrer ARAG-Krankenversicherung werden von Roodie an die Quality Smile GmbH  zum Zweck der Zahnarzt-/Zahnlaborsuche weitergegeben und von dieser ausschließlich zu diesem Zweck verarbeitet und genutzt.  Ferner wird der Vorschlag geeigneter Zahnärzte/-labors (Vorname, Nachname, Fachrichtung bzw. Laborname, Anschrift) von Quality Smile an Roodie übermittelt, um diese Informationen in Ihrem Konto in der Roodie ARAG App anzuzeigen und zu speichern. Diese Einwilligung kann von Ihnen jederzeit widerrufen werden.</p><p>Es handelt sich dabei um personenbezogene Daten, die sich auf Ihre körperliche oder mentale Gesundheit einschließlich der Erbringung von Gesundheitsdienstleistungen beziehen und aus denen Informationen über Ihren Gesundheitszustand hervorgehen. Rechtsgrundlage für die Verarbeitung dieser Daten ist Ihre Einwilligung gemäß Art 9 Abs 2 lit a DSGVO. Bitte beachten Sie, dass bei Weiterleitung an Quality Smile bekannt wird, dass für Sie eine Krankenversicherung bei der ARAG-Krankenversicherung besteht.</p>";
    },
    privacyRevocationText() {
      let result = "";
      if (
        this.routing.startsWith("ARAG Case Management") ||
        this.from === "contact"
      ) {
        result =
          "Es steht Ihnen frei, die Einwilligung/Schweigepflichtentbindung jederzeit später mit Wirkung für die Zukunft gegenüber der ARAG Krankenversicherungs-AG zu widerrufen. Wir weisen jedoch darauf hin, dass ohne Verarbeitung von Gesundheitsdaten die Durchführung des Versicherungsvertrages in der Regel nicht möglich sein wird.";
      } else if (this.routing === "BetterDoc") {
        result =
          "Es steht Ihnen frei, die Einwilligung/Schweigepflichtentbindung jederzeit später mit Wirkung für die Zukunft gegenüber BetterDoc zu widerrufen. Wir weisen jedoch darauf hin, dass ohne Verarbeitung von Gesundheitsdaten eine Unterstützung für Ihr gesundheitliches Anliegen in der Regel nicht möglich sein wird.";
      } else if (this.routing === "Quality Smile") {
        result =
          "Es steht Ihnen frei, die Einwilligung/Schweigepflichtentbindung jederzeit später mit Wirkung für die Zukunft gegenüber der Quality Smile GmbH zu widerrufen. Wir weisen jedoch darauf hin, dass ohne Verarbeitung von Gesundheitsdaten eine Unterstützung für Ihr gesundheitliches Anliegen in der Regel nicht möglich sein wird.";
      }
      return result;
    },
  },
  watch: {
    // privacy1() {
    //   this.checkPrivacy();
    // },
    privacyRoodieCheck() {
      this.checkPrivacy();
    },
    privacy2() {
      this.checkPrivacy();
    },
  },
  methods: {
    checkPrivacy() {
      if (
        // this.privacy1 &&
        (this.from !== "contact" && this.privacy2) ||
        (this.from === "contact" && this.privacyRoodieCheck && this.privacy2)
      ) {
        this.$emit("checked", {
          privacy1Label: this.privacy1Label,
          privacy2Label: this.privacy2Label,
        });
      } else {
        this.$emit("unchecked");
      }
    },
    submit() {
      if (this.link) {
        window.open(this.link, "_blank");
      } else {
        this.$emit("done");
      }
    },
    async openInfoModal(text) {
      const modal = await modalController.create({
        component: InfoModal,
        cssClass: "my-custom-class",
        componentProps: {
          title: "",
          text: text,
        },
      });
      return modal.present();
    },
  },
  setup() {
    const isPopoverOpenRef = ref(false);
    const isPrivacy2PopoverOpenRef = ref(false);
    const popoverEvent = ref();
    const setPopoverOpen = (state, ev) => {
      popoverEvent.value = ev;
      isPopoverOpenRef.value = state;
    };
    const setPrivacy2PopoverOpen = (state, ev) => {
      popoverEvent.value = ev;
      isPrivacy2PopoverOpenRef.value = state;
    };
    return {
      informationCircle,
      isPopoverOpenRef,
      isPrivacy2PopoverOpenRef,
      popoverEvent,
      setPopoverOpen,
      setPrivacy2PopoverOpen,
    };
  },
};
</script>

<style lang="scss" scoped>
.c-logo {
  max-width: 200px;
  display: inline-block;
  margin-right: 20px;
}

.u-danger {
  --border-color: var(--ion-color-danger);
  --border-width: 2px;
}
</style>
